import { useParams, useNavigate } from 'react-router-dom'
import { useTheme } from 'styled-components'

import { useFindTask } from '@hooks/task/find'
import { Pill } from '@screens/Task/components/Pill'

import { StatusPill } from './StatusPill'
import { PillContainer } from './styles'

export function TaskPills() {
  const theme = useTheme()
  const { taskId } = useParams<{ taskId: string }>()
  const { data: rawTask } = useFindTask(Number(taskId))

  const task = rawTask ?? ({} as NonNullable<typeof rawTask>)

  return (
    <PillContainer>
      <StatusPill status={task.status} />
      {task.hasBarrier && <Pill color={theme.colors.hasBarrier}>BARRIER</Pill>}
      {task.isSplit && <Pill color={theme.colors.isSplit}>SPLIT</Pill>}
      {task.isPullAhead && (
        <Pill color={theme.colors.isPullAhead}> PULL AHEAD</Pill>
      )}
      {task.isReset && <Pill color={theme.colors.isReset}>RESET</Pill>}
      {task.isBreakIn && <Pill color={theme.colors.isBreakIn}> BREAK IN</Pill>}
    </PillContainer>
  )
}
